import { calculateValue } from 'checkout/selectors/payment/generic'

interface TicketViewOptions {
  isBookDates?: boolean
  orderItemId?: string,
  ticketValidation?: App.ExperienceCheckoutItemValidationState['string'],
  isAccomBundle?: boolean
}

/**
 * Iterate through the item in the cart and sum the price and memberPrice
 * @param cartTicketItem
 * @param ticket
 * @param options
 * @returns
 */
export function mapExperienceCartItemToSummaryViews(
  cartTicketItem: App.Checkout.ExperienceItemTicket,
  ticket: App.ExperienceItemTicket | undefined,
  options: TicketViewOptions = {},
): App.Checkout.ExperienceItemTicketSummaryView | undefined {
  const { ticketId, count } = cartTicketItem

  const ticketPrice = ticket?.price ?? 0
  const ticketMemberPrice = ticket?.memberPrice ?? 0
  const isZeroPriced = options.isBookDates
  let price = isZeroPriced ? 0 : ticketPrice * cartTicketItem.count
  let memberPrice = isZeroPriced ? 0 : ticketMemberPrice * cartTicketItem.count

  if (cartTicketItem.loyaltyTransferDiscount && price) {
    // this is our special loyalty transfer discount, so make one of the items 'free'
    price -= ticketPrice
    memberPrice -= ticketMemberPrice
  }

  if (cartTicketItem.count === 0) {
    return undefined
  }

  const isTicketValid = options.ticketValidation ? options.ticketValidation.fetching || options.ticketValidation.isValid : true

  return {
    ticketId,
    name: ticket?.name ?? cartTicketItem.name,
    fareType: ticket?.fareType ?? '',
    price,
    memberPrice,
    value: calculateValue(price, ticket?.discounts.base.percentage ?? 0),
    discounts: {
      base: {
        amount: ticket?.discounts.base.amount ?? 0,
        percentage: ticket?.discounts.base.percentage ?? 0,
      },
      app: {
        amount: ticket?.discounts.app.amount ?? 0,
        percentage: ticket?.discounts.app.percentage ?? 0,
      },
    },
    count,
    unavailable: !ticket || !isTicketValid,
    purchaseLimit: ticket?.purchaseLimit ?? { min: 1, max: 9999, maxReason: 'AVAILABILITY' },
    taxesAndFees: ticket?.taxesAndFees ?? 0,
    participantsPerUnit: ticket?.participantsPerUnit ?? 1,
    numberOfAdults: ticket?.numberOfAdults,
    numberOfChildren: ticket?.numberOfChildren,
    date: ticket?.date,
    time: ticket?.time,
  }
}
